import { Flex } from '@ui-library/misc';
import React from 'react';
import Loading from '@ui-library/Loading';
import classes from './tableMapping.module.scss';
import JsonView from './jsonView';
import TableView from './tableView';
import SelectUserId from './selectUserId';
import TableMappingProvider, {
  TableMappingProviderProps,
  useMappingState,
} from './tableMappingProvider';
import { Header, SubHeader, TableMappingWrapper } from '../style';
import ChooseUserIdentifier from './selectUserId/chooseUserIdentifier';
import ReloadColumns from '../reloadColumns';
import ReloadPreview from './reloadPreview';

interface TableMappingProps {
  show: boolean;
  loadingCols: boolean;
}

const TableMapping = (props: TableMappingProps) => {
  const {
    loading,
    sourceConfig,
    role,
    refreshColumns,
    updateSchemaErrors,
    jsonData,
    refreshPreview,
  } = useMappingState();

  if (props.loadingCols) {
    return (
      <TableMappingWrapper>
        <Header>Preview</Header>
        <SubHeader>
          Loading columns... <Loading size={16} />
        </SubHeader>
      </TableMappingWrapper>
    );
  }
  if (!props.show) {
    return (
      <TableMappingWrapper>
        <Header>Preview</Header>
        {(sourceConfig?.schema && sourceConfig.table) ||
        sourceConfig?.bucketName ||
        sourceConfig?.sqlModelId ? (
          <div className={classes.preview_reload_columns}>
            <ReloadColumns
              sourceConfig={sourceConfig}
              role={role}
              refreshColumns={refreshColumns}
              hide={false}
              updateSchemaErrors={updateSchemaErrors}
            />
          </div>
        ) : (
          <SubHeader>Choose a table to see a preview of your data.</SubHeader>
        )}
      </TableMappingWrapper>
    );
  }

  if (!jsonData) {
    return (
      <TableMappingWrapper>
        <Header>Preview</Header>
        <div className={classes.preview_reload_columns}>
          <ReloadPreview
            sourceConfig={sourceConfig}
            role={role}
            refreshPreview={refreshPreview}
            hide={false}
            updateSchemaErrors={updateSchemaErrors}
          />
        </div>
      </TableMappingWrapper>
    );
  }
  if (loading) {
    return (
      <TableMappingWrapper>
        <Header>Preview</Header>{' '}
        <SubHeader>
          Loading sample data... <Loading size={16} />
        </SubHeader>
      </TableMappingWrapper>
    );
  }
  return (
    <div style={{ width: '100%' }}>
      <TableMappingWrapper className="table-mapping_header">
        <Header>Here’s a snippet of your data</Header>
        <SubHeader>Select and edit the columns to include.</SubHeader>
      </TableMappingWrapper>
      <Flex style={{ width: '100%' }}>
        <div style={{ marginRight: 24, flex: 1, maxWidth: '49%' }}>
          <TableView />
        </div>
        <JsonView />
      </Flex>
    </div>
  );
};

export default (({
  loadingCols,
  ...props
}: TableMappingProviderProps & { loadingCols: boolean }) => (
  <TableMappingProvider {...props}>
    <div className={classes.identifiers__container}>
      <ChooseUserIdentifier show={props.isValid} />
      <div style={{ marginTop: 24 }} />
      <SelectUserId columns={props?.columns} isValid={!!props.isValid} overrideRowName="user_id" />
      <div style={{ marginTop: 24 }} />
      <SelectUserId
        columns={props?.columns}
        isValid={!!props.isValid}
        overrideRowName="anonymous_id"
      />
    </div>
    <TableMapping show={props.isValid} loadingCols={loadingCols} />
  </TableMappingProvider>
)) as React.FC<TableMappingProviderProps & { loadingCols: boolean }>;
